import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin: 25px 0;
  width: 96%;
  height: 100%;
  padding: 5px;
  border-radius: 1px;
`;
